import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class FuelConsumptionService {

    private api_url = environment.url;

    constructor(private http: HttpClient) {}

    create(data: any, dashboardFiles: File[], tankFiles: File[]) {
        const formData = new FormData();
        Object.keys(data).forEach(key => {
            if (data[key] !== null && data[key] !== undefined) {
                formData.append(key, data[key]);
            }
        });
        dashboardFiles.forEach(f => formData.append('images[dashboard][]', f));
        tankFiles.forEach(f => formData.append('images[tank][]', f));
        return this.http.post(`${this.api_url}fuel-consumption`, formData);
    }

    getByUnit(unitId: number, weekStartDate: string) {
        return this.http.get(`${this.api_url}fuel-consumption/unit/${unitId}`, {
            params: { week_start_date: weekStartDate }
        });
    }

    validateRecord(id: number, data: { is_valid: boolean; validation_notes?: string; validated_by: string }) {
        return this.http.put(`${this.api_url}fuel-consumption/${id}/validate`, data);
    }
}